module.exports = __webpack_public_path__ + "img/home-active.d8c584db.png";